import { render, staticRenderFns } from "./SiteFeedback.vue?vue&type=template&id=6ccd584c&"
import script from "./SiteFeedback.vue?vue&type=script&lang=js&"
export * from "./SiteFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports